const MODAL_NAME = "setProjectMonthlySpendModal";

export { MODAL_NAME };
